import styled from "styled-components";

export const ContactContainer = styled.div`
  min-width: 25vw;
  height: 87vh;
  @media (max-width: 768px) {
    width: 100vw;
    height: 84vh;
  }
`;
export const ContactScrollWrapper = styled.div`
  height: 90%;
  overflow-y: scroll;
  padding: 0 5px;
  &::-webkit-scrollbar {
    width: 2px;
    border-radius: 3px;
    background-color: #00000020;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #000000ce;
    width: 2px;
    border-radius: 3px;
  }
`;
export const ContactUser = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  border-bottom: 1px solid #6666667d;
  padding: 10px;
  margin: 10px 0;
  &:last-child {
    border-bottom: 0;
  }

  div:nth-child(1) {
    align-items: center;
    display: flex;
    gap: 10px;
    img {
      width: 50px;
      height: 50px;
      object-fit: cover;
      border-radius: 50%;
    }
    div {
      gap: 5px;
      display: flex;
      flex-direction: column;
      span:nth-child(1) {
        color: black;
        text-transform: capitalize;
        font-weight: 600;
      }
      span:nth-child(2) {
        font-size: 13px;
      }
    }
  }
  div:nth-child(2) {
    button {
      background: #000;
      padding: 5px 20px;
      border-radius: 20px;
      display: flex;
      align-items: center;
      text-transform: capitalize;
      gap: 5px;
      border: 0;
      font-weight: 300;
      font-size: 15px;
      outline: none;
    }
  }
`;
// export const NoChatContainer = styled.div``
// export const NoChatContainer = styled.div``
